export default "__VITE_ASSET__CHb63aAd__"